<template>
  <header>
    <div class="preffix">
      <slot/>
    </div>

    <IconBackward
      :class="['back', { active: canBackward }]"
      @click.prevent="canBackward && $emit('backward')"
    />

    <div 
      :class="['center', { active }]"
      @click.prevent="$emit('help')"
    >
      <component 
        :is="active ? 'IconEye' : 'IconEyeClose'"
        :size="active ? 'calc(2.22222em * 20 / 36)' : '1em'"
      />
    </div>

    <IconBackward
      :class="['next', { active: canForward }]"
      @click.prevent="canForward && $emit('forward')"
    />

    <AppSubTitle 
      v-if="active" 
      v-text="title"
      @click.prevent="$emit('help')"
    />
  </header>
</template>


<script>
import IconEye from '@/components/icons/IconEye';
import IconEyeClose from '@/components/icons/IconEyeClose';
import IconBackward from '@/components/icons/IconBackward';
import AppSubTitle from '@/components/game/ui/AppSubTitle';

export default {
  name: 'GameHeader',

  components: {
    IconEye,
    IconEyeClose,
    IconBackward,
    AppSubTitle,
  },

  props: {
    canBackward: Boolean,
    canForward: Boolean,
    title: [String, Boolean],
    active: Boolean,
  },
};
</script>


<style lang="scss" scoped>
header {
  width: 100%;
  display: grid;
  grid-template-columns: auto 1fr auto;
  grid-template-rows: 1em 1em;
  position: relative;
  color: #4D43C6;
  gap: 8px 2em;

  & > .preffix {
    position: absolute;
    bottom: calc(100% + 24px);
    max-width: 200px;
    z-index: 1;
  }

  .next, .back {
    height: 16px;
    @media (hover: hover) {
      &.active {
        cursor: pointer;
        transition: scale .1s, opacity .1s;
        &:hover {
          opacity: .9;
          scale: .95;
        }
      }
    }

    &:not(.active) {
      cursor: no-drop;
      opacity: .5;
    }
  }

  .back {
    transform: rotate(180deg);
  }

  .center {
    font-size: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    text-align: center;

    @media (hover: hover) {
      cursor: pointer;
      transition: scale .1s, opacity .1s;
      &:hover {
        opacity: .9;
        scale: .95;
      }
    }

    &.active > svg {
      position: absolute;
    }

    &:not(.active) > svg {
      transform: translateY(.5em);
    }
  }

  & > h2 {
    grid-column: 1 / 4;
    text-align: center;
    color: var(--color-primary);
    user-select: none;
    cursor: pointer;
  }

  @media screen and (min-width: 800px) and (orientation: landscape) {
    border-radius: 12px;

    h1 {
      font-size: 16px;
    }

    b {
      font-size: 32px;
    }
  }
}
</style>